module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "time"
  }, [_c('v-timeList', {
    attrs: {
      "yearList": _vm.yearList,
      "articleCount": _vm.articleCount,
      "currentPage": _vm.currentPage,
      "pageNum": _vm.pageNum,
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('v-sidebar', {
    attrs: {
      "categories": _vm.categories,
      "tags": _vm.tags,
      "nowCategorie": _vm.nowCategorie,
      "nowTagName": _vm.nowTagName
    },
    on: {
      "getColumnArticle": _vm.getColumnArticle,
      "toTag": _vm.toTag
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6324b600"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/time/index.vue
// module id = 273
// module chunks = 1